import { IconButton, PageHeader } from '@celltrak/ui-components';

import useAgenciesHeader from './hooks';

const AgenciesHeader = () => {
  const { handleCreateClick } = useAgenciesHeader();

  return (
    <header>
      <PageHeader
        title="Agencies"
        actions={
          <IconButton icon="plus" size="sm" onClick={handleCreateClick}>
            Create
          </IconButton>
        }
      />
    </header>
  );
};

export default AgenciesHeader;
